export const columns = (self) =>{
  return [
      {
          label:'属性ID',
          prop:'paId',
          align:"center",
          minminWidth:180,
          headerAlign:"center",
      },
      {
          label:'功能名称',
          prop:'funcName',
          width:100,
          tooltip:true
      },
      {
          label:'字段标识',
          minWidth:180,
          align:"center",
          headerAlign:"center",
          prop:'fieldName'
      },
      {
          label:'数据传输模式',
          minWidth:180,
          align:"center",
          headerAlign:"center",
          tooltip:true,
          prop:'transferMode',
          render: (h, params) => {
              let txt = '';

              if(params.row.transferMode == 'r'){
                txt = '上报'
              }else if(params.row.transferMode == 'w'){
                txt = '下报'
              }else if(params.row.transferMode == 'rw'){
                txt = '上报/下发'
              }
              return h('span',{},txt)
          }
      },
      {
        label:'数据类型',
        minWidth:200,
        align:"center",
        headerAlign:"center",
        tooltip:true,
        prop:'dataType',
        render: (h, params) => {
            
            let arr =  [
              {
                id: 1,
                label: "布尔(Bool)",
              },
              {
                id: 2,
                label: "数字(Vlaue)",
              },
              {
                id: 3,
                label: "枚举(Enum)",
              },
              {
                id: 4,
                label: "故障(Fault)",
              },
              {
                id: 5,
                label: "字符(String)",
              },
              {
                id: 6,
                label: "透传(Raw)",
              },
            ]

           
            return h('span',{},arr[params.row.dataType - 1].label)
        }
    },
      {
          label:'备注',
          width:150,
          align:"left",
          headerAlign:"left",
          prop:'remark',
      },
      {
          label:'附加数据',
          minWidth:160,
          prop:'attachAttr',
      },
      {
          label:'创建时间',
          minWidth:200,
          prop:'createTime',
      },
      {
          label:'状态',
          minWidth:80,
          align:"center",
          headerAlign:"center",
          fixed:"right",
          render: (h, params) => {
            const look = (h) => {
                return h('el-link', {
                      props: {
                          type:'primary',
                          underline:false
                      },
                      style: {

                      },
                      on: {
                          click: () => {
                              self.showOperateBtn(0,params.row);
                          }
                      }
                  }, '编辑');
            };

            const del = (h) => {
              return h('el-link', {
                    props: {
                        type:'primary',
                        underline:false
                    },
                    style: {
                      marginLeft: '10px',
                    },
                    on: {
                        click: () => {
                            self.showOperateBtn(1,params.row);
                        }
                    }
                }, '删除');
          };
           
            const buttons = [];
              buttons.push(look(h),del(h))
              return h('div', {
                  
              }, buttons);
          }
      }
    ]
}